import { useBrandingContext } from '@/contexts/BrandingContext';

/**
 * Hook to access branding configuration in components.
 * Must be used within a BrandingProvider.
 * 
 * @example
 * const { branding, sources, isLoading, error, refresh } = useBranding();
 * 
 * // Access branding values
 * const logoUrl = branding.logo_url;
 * const primaryColor = branding.primary_color;
 * 
 * // Check where a value came from
 * const logoSource = sources.logo_url; // 'platform' | 'agency' | 'tenant'
 */
export function useBranding() {
  return useBrandingContext();
}

// Re-export types for convenience
export type { BrandingConfig, BrandingSources, BrandingContextValue, BrandingSource } from '@/types/branding';
